import React, { Component } from 'react';
import Modal from './Modal';
import check from "../../assets/check.svg";
import checkColor from "../../assets/checkColor.svg";
import eliminar from "../../assets/eliminar.svg";
import axios from "axios";
import "../../css/Acuerdo.css";
import Header from './Header.js';
import Footer from './Footer.js';
import alarma from "../../assets/alarma.svg";
import equis from "../../assets/eliminar.svg";
import Renderpdfexternos from "../components/renderPDFExternos";
import CenteredWrapper from '../components/CenteredWrapper.js';
import BotonExpandible from "../components/BotonExpandible";

export class AcuerdoUsuariosExternos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            aceptoAcuerdo: false,
            activebutton: true,
            fecha: new Date(),
            datosUsuario: {
                nombres: this.props.nombres || "Undefined",
                apellidos: this.props.apellidos || "Undefined",
                identificacion: this.props.identificacion || "Undefined",
                tipoIdentificacion: this.props.tipoIdentificacion || "Undefined",
                usuario_sugerido: this.props.usuario_sugerido || "Undefined",
                password: this.props.password || "",
                fechaNacimiento: this.props.fechaNacimiento || "",
                sexo: this.props.sexo || ""
            },
            modalError: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: eliminar,
            },
            modalFirmaGeneralExitosa: false,
            modalNoAcepACGeneral: false,
            firmarPDF: false,
            loading: false,
        };

        this.PostFirmarAcuerdoGen = this.PostFirmarAcuerdoGen.bind(this);
        this.PostNoFirmarAcuerdoGen = this.PostNoFirmarAcuerdoGen.bind(this);
        this.cerrarModalFirmaGeneralExitosa = this.cerrarModalFirmaGeneralExitosa.bind(this);
        this.cerrarModalNoAcepACGeneral = this.cerrarModalNoAcepACGeneral.bind(this);
        this.getSexoType = this.getSexoType.bind(this);
        this.handleFirmarPDF = this.handleFirmarPDF.bind(this);     
        this.cerrarModalError = this.cerrarModalError.bind(this);   
    }

    getSexoType(Type) {
        if (Type == 'Hombre') {
          return 'M';
        } else {
          return 'F';  
        }  
    }

    handleFirmarPDF() {
        this.setState({
            firmarPDF: true,
            loading: true,
            activebutton: false
        });
    }


    PostFirmarAcuerdoGen = async (e) => {
        // e.preventDefault();
        // this.disabledbuttonf();
        this.setState({ loading: true });
        window.grecaptcha.ready(()=>{
            window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token =>{
                var firmarDocumento = {
                    nombre: this.state.datosUsuario.nombres,
                    apellido: this.state.datosUsuario.apellidos,          
                    identificacion: this.state.datosUsuario.identificacion,
                    acuerdoBase64: this.state.acuerdob64,
                }
                
                const config = {
                    headers: {
                        'X-Recaptcha-Token': token
                    }
                };

                axios.post(`${process.env.REACT_APP_API_EXT}/Account/FirmarDocumento`, firmarDocumento, config)
                .then((response) => {
                    if (response.data?.status?.isSuccessfully){
                        console.log("respuesta isSuccessfully");
                        let referenciaAcuerdo = response.data.data.referencia;
                        const { identificacion, nombres, apellidos, tipoIdentificacion, usuario_sugerido, password, fechaNacimiento, sexo } = this.state.datosUsuario;
                        
                        let crearCuenta = {
                            tipo_identificacion: tipoIdentificacion,
                            identificacion: identificacion,
                            nombres: nombres,
                            apellidos: apellidos,
                            email: usuario_sugerido,
                            password: password,
                            fecha_nacimiento: fechaNacimiento,
                            sexo: this.getSexoType(sexo),
                            idAcuerdo: referenciaAcuerdo,
                        };

                        window.grecaptcha.ready(() => {
                            window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
                                const configCrearCuenta = {
                                    headers: {
                                        'X-Recaptcha-Token': token
                                    }
                                }

                                //POST CREAR CUENTA
                                axios.post(`${process.env.REACT_APP_API_EXT}/Account/CrearCuenta`, crearCuenta, configCrearCuenta)
                                .then(response => {
                                    if (response.data?.status?.isSuccessfully) {
                                        this.setState({ 
                                            activebutton: false,
                                            loading: false,
                                            modalFirmaGeneralExitosa: true
                                        });
                                    } else {                                
                                        this.setState({
                                            loading: false,
                                            activebutton: true,
                                            firmarPDF: false,
                                            modalError: {
                                                show: true,
                                                titulo: "Error",
                                                mensaje: "Lo sentimos, hubo un problema al crear su cuenta.",
                                                imagen: equis,
                                            }
                                        });
                                    }
                                })
                                .catch(error => {
                                    this.setState({
                                        loading: false,
                                        activebutton: true,
                                        firmarPDF: false,
                                        modalError: {
                                            show: true,
                                            titulo: "Error",
                                            mensaje: "Ocurrió un error en el servidor.",
                                            imagen: equis,
                                        }
                                    });
                                });
                            });
                        });
                    } else {
                        this.setState({
                            loading: false,
                            activebutton: true,
                            firmarPDF: false,
                            modalError: {
                                show: true,
                                titulo: "Error",
                                mensaje: response.data.status.messages[0],
                                imagen: equis,
                            }
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        loading: false,
                        activebutton: true,
                        firmarPDF: false,
                        modalError: {
                            show: true,
                            titulo: "Error",
                            mensaje: "Ocurrió un error en el servidor.",
                            imagen: equis,
                        }
                    });
                });
            });
        });
    }

    PostNoFirmarAcuerdoGenLegacy = async (e) => {
        console.log("PostNoFirmarAcuerdoGen");
        // e.preventDefault();
        // this.disabledbuttonf1();
        //console.log("guardar registro de no firma acuerdo general");
        let datos = {
            estado: 1,
            aceptodatospers: 0,
            aceptomedelect: 0,
            rutaacuerdodatospersfirmado: "",
            rutaacuerdomedelectfirmado: "",
            identificacion: this.state.datosUsuario.identificacion
        }
        axios.post(`${process.env.REACT_APP_API}api/PersonaDago/signautoagreement`, datos)
            .then(resp => {
                console.log(resp.data);
                // this.activebuttonf1();
                // this.abrirModalNoAcepACGeneral();
                //this.abrirModalNoAcepACGeneralPrev();
            }).catch(error => {
                console.log(error.message);
                // this.setState({
                //     modalErrorAcuerdoGen: {
                //         show: true,
                //         titulo: "Error al guardar el registro de la firma",
                //         mensaje: error.response.data,
                //         imagen: equis,
                //     }
                // });
                // this.activebuttonf1();
            })
            
    }


   
    DataAcuerdo = arcb64 => {
        this.setState({ 
            acuerdob64: arcb64,
            loading: true
        }, () => {            
            this.PostFirmarAcuerdoGen();
          });
    }


    PostFirmarAcuerdoGenBACK(e) {

        //cambiar para mandar el post
        e.preventDefault();
        this.setState({ 
            activebutton: false,
            modalFirmaGeneralExitosa: true 
        });
    }

    PostNoFirmarAcuerdoGen(e) {
        e.preventDefault();
        this.setState({ 
            modalNoAcepACGeneral: true 
        });
    }

    cerrarModalFirmaGeneralExitosa() {
        this.setState({ modalFirmaGeneralExitosa: false });
        // aqui hay que redirigir
        const redirect = sessionStorage.getItem("redirect_after_register");

        if (redirect) {
            sessionStorage.removeItem("redirect_after_register");
            window.location.href = redirect;
        } else {
            window.location.href = '/inicio';
        }
    }

    cerrarModalNoAcepACGeneral() {
        this.setState({ modalNoAcepACGeneral: false });
    }

    cerrarModalError() {
        this.setState({
            modalError: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
        //console.log("cerrar modal " + this.state.modalMessage);
    }


    render() {
        this.props.useEffect();
        
        const formattedDate = this.state.fecha.toLocaleDateString('es-ES', { 
            day: 'numeric', 
            month: 'long', 
            year: 'numeric' 
        });

        return (
            <div>
                <Header />
                <CenteredWrapper>
                    <div className="acuerdo-container">
                        <div className="container">
                            <div className="row">
                                <BotonExpandible 
                                    mensaje={
                                    <strong>
                                        Estimado usuario, en cumplimiento de la Ley Orgánica de protección de datos personales,
                                        ponemos a su conocimiento el siguiente acuerdo para el uso de datos personales y medios electrónicos.
                                    </strong>
                                    }
                                />
                                {/* <div>
                                    <div className="acuerdogeneral-container">
                                        <div className="container">
                                            <div className="row">
                                                <div>
                                                    <p className="acuerdogeneral-subtitulo" align="justify">
                                                        <img src={importante} className="acuerdogeneral-btn-logop" /> 
                                                        IMPORTANTE
                                                    </p>
                                                    <p className="acuerdogeneral-parraf" align="justify">
                                                        <strong>Estimado Usuario, en cumplimiento de la Ley Orgánica de Protección de Datos Personales, ponemos a su conocimiento el siguiente Acuerdo para el Uso de Datos Personales y Medios Electrónicos: </strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <br />
                        <div className="row">
                            <div className="col-md-1 col-lg-2 col-xl-1"></div>
                            <div className="col-md-10 col-lg-8 col-xl-10 acuerdo-recuadro" align="center">
                                <div className="row acuerdo-recuadro-titulo mt-4">
                                    <p><b>ACUERDO DE USO DE DATOS PERSONALES Y MEDIOS ELECTRÓNICOS PARA EL ALMACENAMIENTO Y USO DE INFORMACIÓN REGISTRADA EN LOS SISTEMAS INFORMÁTICOS DE LA ESPOL</b></p>
                                </div>
                                <div className="row mt-2 px-3 acuerdo-recuadro-texto" align="justify">
                                    <p>La Escuela Superior Politécnica del Litoral – (en adelante ESPOL) es una institución de educación superior, persona jurídica de derecho público, sin fines de lucro, autónoma en lo académico, administrativo, financiero y orgánico, pone en su conocimiento las condiciones de uso, fines y almacenamiento de los datos personales proporcionados por usted; así como, las condiciones de uso del usuario y contraseña de los medios y servicios electrónicos que la ESPOL provee a través del internet.</p>
                                </div>
                                <div className="row acuerdo-recuadro-subtitulo-izq">
                                    <p><b>Declaración de responsabilidad y aceptación de usuario:</b></p>
                                </div>
                                <div className="row mt-2 px-3 acuerdo-recuadro-texto" align="justify">
                                    <p>Con estos antecedentes. Usted, {this.state.datosUsuario.nombres.toUpperCase()} {this.state.datosUsuario.apellidos.toUpperCase()}, en adelante el Usuario,
                                        con número de identificación {this.state.datosUsuario.identificacion} y usuario {this.state.datosUsuario.usuario_sugerido} en Guayaquil, Ecuador; el día {formattedDate},
                                        declara que:</p>
                            
                                    <div className="Aut_dtos_personales" align="justify">
                                        <p>1) Se compromete a registrar la información requerida por la institución de manera fidedigna y coherente en los sistemas informáticos de la ESPOL.</p>

                                        <p>2) Acepta y autoriza que la ESPOL almacene sus datos personales por tiempo indefinido, y
                                            serán protegidos de acuerdo a la Ley Orgánica de Protección de Datos Personales. Estos
                                            datos podrán ser compartidos con las empresas públicas, fundaciones y empresas con las que                                                  
                                            la ESPOL esté relacionada, enmarcado en los fines del tratamiento de datos personales
                                            dispuesto en las políticas de privacidad de la institución.</p>

                                        <p>3) Acepta y autoriza que la ESPOL haga uso de los datos personales proporcionados, en
                                            concordancia con la <a target="_blank" href="https://www.dspace.espol.edu.ec/bitstream/123456789/57243/3/POLITICA%20DE%20PRIVACIDAD%20ESPOL%20GTSI.pdf">Política de Privacidad</a> y en sus <a target="_blank" href="https://www.dspace.espol.edu.ec/bitstream/123456789/57244/3/TERMINOS%20Y%20CONDICIONES%20POLITICAS%20DE%20PRIVACIDAD%20GTSI.pdf">términos y condiciones</a> vigentes de la
                                            institución.</p>

                                        <p>4) Conoce que su calidad de usuario de los sistemas informáticos de la ESPOL, permite a la
                                            institución el uso de sus datos personales sensibles de acuerdo a la Ley Orgánica de
                                            Protección de Datos Personales y que los mismos serán utilizados como parte de su registro
                                            académico.</p>
                                        
                                        <p>5) Conoce que el portal institucional www.espol.edu.ec es de propiedad de la Escuela Superior Politécnica del Litoral.</p>
                                        
                                        <p>6) Conoce el presente acuerdo y se compromete, a respetar las normas y procedimientos que garanticen la privacidad de la información proporcionada o de la que pudiera tener acceso.</p>

                                        <p>7) Asume la responsabilidad de la información proporcionada; así como también de la vigencia, veracidad, actualización y coherencia de la misma, en cumplimiento de sus obligaciones.</p>
                                        
                                        <p>8) Conoce que, de incurrir en uso inadecuado de los sistemas informáticos de la institución, la ESPOL tendrá derecho tomar las medidas tecnológicas necesarias sobre el usuario de sus sistemas informáticos para precautelar la seguridad informática de los mismos. También, la institución podrá iniciar medidas administrativas correctivas, en caso de falsedad de la información ingresada, mal uso, vulneración de sistemas, entre otras actividades que pudieran poner en riesgos la confidencialidad de datos bajo responsabilidad y custodia de la ESPOL, sin perjuicio de las acciones judiciales que pudiera iniciar la institución.</p>
                                        
                                        <p>9) Conoce que la marca ´´ESPOL + logotipo´´ y sus marcas derivadas se encuentran registradas y gozan de protección de los Derechos de Propiedad Intelectual. En caso de requerir su uso, deberá ser autorizado por la institución.</p>
                                        
                                        <p>10) Conoce que las imágenes, portales, archivos, documentos o cualquier otro material en el que conste la ESPOL + logotipo o sus marcas registradas, es propiedad de la institución, su uso o reproducción deberá ser autorizada, o mencionada dentro del medio para el que se utilice.</p>
                                        
                                        <p>11) Conoce que el usuario y clave que la institución le asigne es personal e intransferible, su uso en las plataformas web de la ESPOL, tendrá validez jurídica de una firma electrónica, de conformidad a lo indicado en la Ley de Comercio Electrónico, Mensaje de Datos y Firma Electrónica y su Reglamento.</p>
                                    </div>
                                </div>

                                {/* <p>12) Declara y conoce que los datos personales serán tratados con medidas de seguridad y confidencialidad adecuadas, y únicamente para los fines establecidos por la ESPOL.</p>
                                </div>
                                </div> */}

                                <div className="row acuerdo-recuadro-subtitulo-centro mt-4">
                                <p><b>II.- Acuerdo de Uso de Medios Electrónicos</b></p>
                                </div>
                                <div className="row mt-2 px-3 acuerdo-recuadro-texto" align="justify">
                                <p>La Escuela Superior Politécnica del Litoral – ESPOL, pone a disposición de la comunidad universitaria medios electrónicos, aplicativos, plataformas y servicios institucionales de tecnología de la información para el cumplimiento de actividades académicas, administrativas y de gestión.</p>
                                </div>

                                <div className="row acuerdo-recuadro-subtitulo-izq mt-4">
                                <p><b>Declaración de responsabilidad:</b></p>
                                </div>
                                <div className="row mt-2 px-3 acuerdo-recuadro-texto" align="justify">
                                    <p>Con estos antecedentes, usted, {this.state.datosUsuario.nombres.toUpperCase()} {this.state.datosUsuario.apellidos.toUpperCase()}, en adelante el Usuario, con número de identificación {this.state.datosUsuario.identificacion} y usuario {this.state.datosUsuario.usuario_sugerido} en Guayaquil, Ecuador, declara que:</p>
                                    <div className="Aut_dtos_personales" align="justify">
                                        <p>1) El usuario y contraseña proporcionados son personales e intransferibles.</p>
                                        <p>2) Todas las actividades realizadas mediante el uso de sus credenciales son de su exclusiva responsabilidad.</p>
                                        <p>3) Los sistemas y plataformas institucionales deben ser usados exclusivamente para fines académicos, investigativos y administrativos.</p>
                                        <p>4) Ha sido informado del uso adecuado de estos recursos y acepta las condiciones establecidas por la institución.</p>
                                        <p>5) Acepta que cualquier documento o interacción dentro de las plataformas institucionales tiene validez legal.</p>
                                        <p>6) Conoce que la institución monitorea el uso de sus sistemas para garantizar la seguridad y el cumplimiento de normas.</p>
                                        <p>7) Se compromete a no compartir, divulgar ni permitir el acceso a terceros con sus credenciales institucionales.</p>
                                        <p>8) Conoce y acepta las políticas institucionales sobre privacidad, uso de datos, sistemas y propiedad intelectual.</p>
                                        <p>9) Asume la responsabilidad por el manejo de información sensible a la que tenga acceso en el ejercicio de sus funciones.</p>
                                        <p>10) La ESPOL se reserva el derecho de tomar medidas administrativas, técnicas y legales ante cualquier incumplimiento.</p>
                                        <p>11) Es responsable del uso que haga de los recursos institucionales incluso si actúa por encargo de terceros.</p>
                                        <p>12) La ESPOL podrá auditar y registrar los accesos a sus sistemas para fines de control y seguridad.</p>
                                        <p>13) El usuario, al firmar el presente acuerdo, declara haber leído y comprendido todas las condiciones antes mencionadas.</p>
                                    </div>
                                    <p>Para constancia de lo expresado, suscribo el presente documento, en la ciudad de GUAYAQUIL, Provincia de GUAYAS el {formattedDate}.</p>
                                </div>

                                {/* <div className="row acuerdo-recuadro-texto mt-4" align="justify">
                                <p>Para constancia de lo expresado, suscribo el presente documento, en la ciudad de GUAYAQUIL, Provincia de GUAYAS el {formattedDate}.</p>
                                <br/>
                                </div> */}


                                {/* <div className="datos-usuario-firma text-center mt-4 mb-5">
                                    <p>{this.state.datosUsuario.usuario_sugerido}</p>
                                    <p>Firma</p>
                                    <p>{this.state.datosUsuario.nombres.toUpperCase()} {this.state.datosUsuario.apellidos.toUpperCase()}</p>
                                    <p>{this.state.datosUsuario.identificacion}</p>
                                </div> */}
                                
                                <div className="row my-3 justify-content-around">
                                    <div className="col-10 col-md-8 col-xl-5">
                                        <button onClick={this.PostNoFirmarAcuerdoGen}
                                            className="acuerdo-recuadro-buttonFE">
                                            <div className="row-btn-denegar-acuerdo">
                                                <div className="">
                                                    <p className="acuerdo-recuadro-texto-button">DENEGAR</p>
                                                </div>
                                                <div className="">
                                                    <img className="acuerdo-logopFE" src={eliminar} alt="No aceptar" />
                                                </div>                                                
                                            </div>
                                        </button>
                                    </div>

                                    <div className="col-10 col-md-8 col-xl-5">
                                        <button onClick={this.handleFirmarPDF} 
                                            className={!this.state.activebutton || this.state.loading ? "acuerdo-recuadro-buttonFM-disabled" : "acuerdo-recuadro-buttonFM"}
                                            disabled={!this.state.activebutton || this.state.loading}
                                        >
                                            <div className="row-btn-aceptar-acuerdo">                                                
                                                <div className="">
                                                    <p className="acuerdo-recuadro-texto-button">
                                                        Aceptar
                                                    </p>
                                                </div>
                                                <div className="">
                                                    <img className="acuerdo-logopFM" src={check} alt="Aceptar" />
                                                </div>
                                            </div>
                                        </button>
                                        {!this.state.activebutton &&
                                            <span className="spinner-border spinner-border-sm text-primary ms-1" role="status" aria-hidden="true"></span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-lg-2 col-xl-1"></div>
                        </div>
                    </div>
                </CenteredWrapper>
                <Footer />

                {this.state.firmarPDF && (
                    <Renderpdfexternos
                        nombre={this.state.datosUsuario.nombres}
                        apellido={this.state.datosUsuario.apellidos}
                        identificacion={this.state.datosUsuario.identificacion}
                        username={this.state.datosUsuario.usuario_sugerido}
                        arcb64={this.DataAcuerdo}
                        firmadoGeneral={this.state.firmadoGeneral}
                        mostrarNombre={this.state.mostrarNombre}
                        posicion="nomodal"
                    />
                )}

                {this.state.modalFirmaGeneralExitosa &&
                    <Modal isOpen={this.state.modalFirmaGeneralExitosa} 
                           cerrarModal={this.cerrarModalFirmaGeneralExitosa} 
                           verBoton={true} 
                           textoBoton="ACEPTAR">
                        <p className='text-center acuerdo-modalFME-titulo'><strong>ACUERDO ACEPTADO</strong></p>
                        <div className='mb-3'>
                            <img className="acuerdo-check" src={checkColor} alt="Exitoso" />
                        </div>
                        <p className='text-center acuerdo-modalFME-texto'>
                            <strong>Usted aceptó con éxito el acuerdo de uso de datos personales y medios electrónicos de la ESPOL.</strong>
                        </p>
                    </Modal>
                }

                {this.state.modalNoAcepACGeneral &&
                    <Modal isOpen={this.state.modalNoAcepACGeneral} 
                           cerrarModal={this.cerrarModalNoAcepACGeneral} 
                           verBoton={true} 
                           textoBoton="CERRAR">
                        <p className='text-center acuerdo-modalFME-titulo'><strong>ACUERDO NO ACEPTADO</strong></p>
                        <div className='mb-3'>
                            <img className="acuerdo-check" src={alarma} alt="Advertencia" />
                        </div>
                        <p className='text-center acuerdo-modalFME-texto'>
                            Estimado, si usted tiene dudas respecto a la aceptación del acuerdo de uso de datos personales y medios electrónicos de la ESPOL, ponemos a su disposición el correo de consulta <a href="mailto:datospersonales@espol.edu.ec">datospersonales@espol.edu.ec</a> con el proposito de aclararle sus inquietudes.
                        </p>
                    </Modal>
                }

                {this.state.modalError.show &&
                    <Modal isOpen={this.state.modalError.show} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                        <p className='text-center'><strong>{this.state.modalError.titulo}</strong></p>
                        <div className='mt-6 mb-6' align="center">
                        <img className="nacionalidad-check" src={this.state.modalError.imagen} alt="Exitoso"></img>
                        </div>
                        <p className='text-center'>{this.state.modalError.mensaje}</p>
                    </Modal>
                }
            </div>
        );
    }
}

export default AcuerdoUsuariosExternos;